import { render } from "./FormModal.vue?vue&type=template&id=7bbff30e&ts=true"
import script from "./FormModal.vue?vue&type=script&lang=ts"
export * from "./FormModal.vue?vue&type=script&lang=ts"

import "./FormModal.vue?vue&type=style&index=0&id=7bbff30e&lang=scss"

import exportComponent from "/Users/andrski/developing/web/client_shina_m1/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__